import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import config from '../../config';
import { Checkbox } from "primereact/checkbox";
import Select from "react-dropdown-select";
// const MAX_PRIORITY = 50;
function UpdateProjectDetail() {
    const { id } = useParams(); // Get the project ID from the URL
    const navigate = useNavigate();
    const [project, setProject] = useState({});
    const [activeLanguage, setActiveLanguage] = useState('en');
    const [newImages, setNewImages] = useState([]);
    const [featuredImage, setFeaturedImage] = useState(null);
    const [contentBanner, setContentBanner] = useState(null);
    const [used, setUsed] = useState([]);
    const [available, setAvailable] = useState([]);
    const [selected, setSelected] = useState(null);
    const [MAX_PRIORITY, setMAX_PRIORITY] = useState(0)
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const fileInputRef = useRef(null);
    const bannerImageRef = useRef(null);
    const featuredImageRef = useRef(null);
    const [loading, setLoading] = useState(false);


    const [centerContent, setCenterContent] = useState([
        { description: '', image: null, isFullWidth: false }
    ]);

    const [spanishCenterContent, setSpanishCenterContent] = useState([
        { description: '', image: null, isFullWidth: false }
    ]);

    // Categories state
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]); // array of {label,value}
    const [selectedCategoryIds, setSelectedCategoryIds] = useState([]); // array of ids/strings
    const [selectedSpanishCategories, setSelectedSpanishCategories] = useState([]); // Spanish categories
    const [selectedSpanishCategoryIds, setSelectedSpanishCategoryIds] = useState([]); // Spanish category ids
    // useEffect(() => {
    //     // Simulate API call with mock data
    //     const mockUsedPriorities = [3, 7, 12, 18, 25, 31, 42, 45];
    //     const mockAvailablePriorities = Array.from({ length: MAX_PRIORITY }, (_, i) => i + 1)
    //         .filter(num => !mockUsedPriorities.includes(num));

    //     setUsed(mockUsedPriorities);
    //     setAvailable(mockAvailablePriorities);
    // }, []);

    const handleSelect = (number) => {
        if (used.includes(number)) return; // ignore used numbers
        setSelected(number);
    };



    const unsetPriority = async () => {
        try {
            //   const response = await axios.get(`${config.BASE_URL}/api/admin/get-project/${id}`, { withCredentials: true });

            // const response = await axios.patch(`${config.BASE_URL}/api/admin/projects/${id}/unset-priority`, { withCredentials: true });
            // if (response) {
            //     // navigate(-1)
            // }

            setSelected(null);
        } catch (error) {
            console.error('Failed to remove priority:', error.response?.data || error.message);
            // Show error to user if needed
        }
    };

    const getButtonClasses = (number) => {
        const isUsed = used.includes(number);
        const isSelected = selected === number;

        let classes = 'w-10 h-10 rounded text-sm font-semibold transition-colors duration-150';

        if (isUsed) {
            classes += ' bg-gray-300 text-gray-500 cursor-not-allowed';
        } else if (isSelected) {
            classes += ' bg-blue-500 text-white';
        } else {
            classes += ' bg-green-100 hover:bg-green-200 text-green-800';
        }

        return classes;
    };

    const handleContentChange = (index, event) => {
        const newFields = centerContent.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, [event.target.name]: event.target.value };
            }
            return field;
        });
        setCenterContent(newFields);
    };

    const handleCheckboxChange = (index, checked) => {
        const newFields = centerContent.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, "isFullWidth": checked };
            }
            return field;
        });
        setCenterContent(newFields);
    };

    const addContentFields = () => {
        setCenterContent([...centerContent, { description: '', image: null, isFullWidth: false }]);
    };

    const removeContentFields = (index) => {
        const newFields = centerContent.filter((field, fieldIndex) => index !== fieldIndex);
        setCenterContent(newFields);
    };

    const handleContentImageChange = (index, event) => {
        const image = event.target.files;
        const newFields = centerContent.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, [event.target.name]: image[0] };
            }
            return field;
        });

        setCenterContent(newFields);
    };

    // Spanish Center Content handlers
    const handleSpanishContentChange = (index, event) => {
        const newFields = spanishCenterContent.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, [event.target.name]: event.target.value };
            }
            return field;
        });
        setSpanishCenterContent(newFields);
    };

    const handleSpanishCheckboxChange = (index, checked) => {
        const newFields = spanishCenterContent.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, "isFullWidth": checked };
            }
            return field;
        });
        setSpanishCenterContent(newFields);
    };

    const addSpanishContentFields = () => {
        setSpanishCenterContent([...spanishCenterContent, { description: '', image: null, isFullWidth: false }]);
    };

    const removeSpanishContentFields = (index) => {
        const newFields = spanishCenterContent.filter((field, fieldIndex) => index !== fieldIndex);
        setSpanishCenterContent(newFields);
    };

    const handleSpanishContentImageChange = (index, event) => {
        const image = event.target.files;
        const newFields = spanishCenterContent.map((field, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...field, [event.target.name]: image[0] };
            }
            return field;
        });

        setSpanishCenterContent(newFields);
    };

    const handleImageUpload = async (image) => {
        const formData = new FormData();
        formData.append('image', image);

        try {
            const response = await axios.post(`${config.BASE_URL}/api/admin/upload-image`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data?.image; // Assuming your API returns the image URL
        } catch (error) {
            console.error('Image upload failed:', error);

            return null;
        }
    };


    useEffect(() => {
        // Fetch categories for select
        axios.get(`${config.BASE_URL}/api/admin/categories/list`)
            .then((res) => {
                if (res.data?.success) {
                    const opts = (res?.data?.data || []).map(cat => ({ label: cat?.name, value: cat?._id }));
                    setCategoryOptions(opts);
                }
            })
            .catch(() => { });

        const getPriorities = async () => {
            try {
                const response = await axios.get(`${config.BASE_URL}/api/admin/get-priority`, { withCredentials: true });
                //    setUsed(used);
                //     setAvailable(available);
                setMAX_PRIORITY(response?.data?.maxLimit + 1)
                setUsed(response?.data?.used);
                setAvailable(response?.data?.available)
            } catch (err) {
                // You could show a toast here
                console.error('Failed to load priorities');
            }
        };

        getPriorities();
    }, []);
    useEffect(() => {


        const fetchProjectDetails = async () => {
            try {
                const response = await axios.get(`${config.BASE_URL}/api/admin/get-project-admin/${id}`, { withCredentials: true });
                setProject(response.data);
                setSelected(response?.data?.priorityNumber)
                setCenterContent(response.data.centerContent || [{ description: '', image: null, isFullWidth: false }]);
                setSpanishCenterContent(response.data.spanishData?.centerContent || [{ description: '', image: null, isFullWidth: false }]);

                // Store raw category ids/strings
                if (Array.isArray(response.data?.category)) {
                    setSelectedCategoryIds(response.data.category);
                }

                // Store Spanish category ids/strings
                if (Array.isArray(response.data?.spanishData?.category)) {
                    setSelectedSpanishCategoryIds(response.data.spanishData.category);
                }
            } catch (err) {
                setError('Failed to fetch project details');

                setTimeout(() => {
                    setError('');
                }, 3000);
            }
        };

        fetchProjectDetails();
    }, [id]);

    // When options or selected ids change, build selected option objects
    useEffect(() => {
        if (!categoryOptions || categoryOptions.length === 0) return;
        if (!selectedCategoryIds) return;
        const mapped = selectedCategoryIds
            .map(id => categoryOptions.find(opt => opt.value === id) || null)
            .filter(Boolean);
        setSelectedCategories(mapped);
    }, [categoryOptions, selectedCategoryIds]);

    // When options or Spanish selected ids change, build Spanish selected option objects
    useEffect(() => {
        if (!categoryOptions || categoryOptions.length === 0) return;
        if (!selectedSpanishCategoryIds) return;
        const mapped = selectedSpanishCategoryIds
            .map(id => categoryOptions.find(opt => opt.value === id) || null)
            .filter(Boolean);
        setSelectedSpanishCategories(mapped);
    }, [categoryOptions, selectedSpanishCategoryIds]);

    const handleRemoveImage = async (imageName, repeaterName = null, index = 0) => {
        try {
            const response = await axios.post(`${config.BASE_URL}/api/admin/remove-image-project`, {
                projectId: project._id,
                imageName
            }, { withCredentials: true });

            if (response.status === 200) {
                // Update project state
                setProject(prevProject => {
                    const updatedImages = prevProject.galleryImages.filter(image => image !== imageName);
                    return {
                        ...prevProject,
                        galleryImages: updatedImages,
                        // Check if the removed image was the banner or featured image
                        contentBanner: prevProject.contentBanner === imageName ? null : prevProject.contentBanner,
                        featuredImage: prevProject.featuredImage === imageName ? null : prevProject.featuredImage,
                    };
                });

                if (repeaterName && repeaterName === "centerContent") {
                    let updatedContent = centerContent;
                    updatedContent[index]['image'] = null;
                    setCenterContent(updatedContent);
                }
            } else {
                console.error('Failed to remove image');
            }
        } catch (err) {
            console.error('Error removing image:', err);
        }
    };

    const handleNewImageChange = (e) => {
        setNewImages(e.target.files); // Set new images to be uploaded
    };

    const handleFeaturedImageChange = (e) => {
        setFeaturedImage(e.target.files[0]); // Set the featured image
    };

    const handleBannerImageChange = (e) => {
        setContentBanner(e.target.files[0]); // Set the featured image
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const formData = new FormData();

        formData.append('title', project.title);
        formData.append('priorityNumber', selected);
        formData.append('type', project.type);
        formData.append('ano', project.ano);
        // append English categories
        if (selectedCategories && selectedCategories.length > 0) {
            selectedCategories.forEach(cat => {
                const val = typeof cat === 'string' ? cat : (cat?.value || cat?.label);
                if (val) formData.append('category', val);
            });
        }

        // append Spanish categories
        if (selectedSpanishCategories && selectedSpanishCategories.length > 0) {
            selectedSpanishCategories.forEach(cat => {
                const val = typeof cat === 'string' ? cat : (cat?.value || cat?.label);
                if (val) formData.append('spanishCategory', val);
            });
        }
        formData.append('cliente', project.cliente);

        formData.append('location', project.location);
        formData.append('lightingDesigner', project.lightingDesigner);
        formData.append('interiorDesigner', project.interiorDesigner);
        // interiorDesigner: project.spanishData?.interiorDesigner || '',

        formData.append('photography', project.photography);
        formData.append('partners', project.partners);
        formData.append('isFeatured', project.isFeatured);
        formData.append('isHomePageFeatured', project.isHomePageFeatured);

        // Add new images for gallery
        for (const image of newImages) {
            formData.append('galleryImages', image);
        }

        // Add the featured image if selected
        if (featuredImage) {
            formData.append('featuredImage', featuredImage);
        }

        if (contentBanner) {
            formData.append('contentBanner', contentBanner);
        }

        // English Center Content
        if (centerContent.length > 0) {
            var updatedCenterContent = [];
            await Promise.all(centerContent.map(async (item, index) => {
                if (item?.image) {
                    if (typeof item?.image == "object") {
                        var imageData = await handleImageUpload(item?.image);
                        updatedCenterContent.push({ description: item.description, image: imageData, isFullWidth: item.isFullWidth });
                    } else {
                        updatedCenterContent.push({ description: item.description, image: item?.image, isFullWidth: item.isFullWidth });
                    }
                } else {
                    updatedCenterContent.push({ description: item.description, image: null, isFullWidth: item.isFullWidth });
                }
            }));
            formData.append('centerContent', JSON.stringify(updatedCenterContent));
        }

        // Spanish Center Content
        if (spanishCenterContent.length > 0) {
            var updatedSpanishCenterContent = [];
            await Promise.all(spanishCenterContent.map(async (item, index) => {
                if (item?.image) {
                    if (typeof item?.image == "object") {
                        var imageData = await handleImageUpload(item?.image);
                        updatedSpanishCenterContent.push({ description: item.description, image: imageData, isFullWidth: item.isFullWidth });
                    } else {
                        updatedSpanishCenterContent.push({ description: item.description, image: item?.image, isFullWidth: item.isFullWidth });
                    }
                } else {
                    updatedSpanishCenterContent.push({ description: item.description, image: null, isFullWidth: item.isFullWidth });
                }
            }));
            formData.append('spanishCenterContent', JSON.stringify(updatedSpanishCenterContent));
        }

        // Spanish translation payload
        formData.append('spanishData', JSON.stringify({
            language: 'es',
            title: project.spanishData?.title || '',
            category: selectedSpanishCategoryIds || [],
            type: project.spanishData?.type || '',
            ano: project.spanishData?.ano || '',
            cliente: project.spanishData?.cliente || '',

            location: project.spanishData?.location || '',
            lightingDesigner: project.spanishData?.lightingDesigner || '',
            interiorDesigner: project.spanishData?.interiorDesigner || '',
            photography: project.spanishData?.photography || '',
            partners: project.spanishData?.partners || '',
            centerContent: updatedSpanishCenterContent,
            contentBanner: project.spanishData?.contentBanner || ''
        }));

        try {
            const response = await axios.put(`${config.BASE_URL}/api/admin/update-project/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                withCredentials: true,
            });

            // Update the project state with the response data
            setProject(response.data.project);
            setCenterContent(response.data.project?.centerContent);

            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            if (featuredImageRef.current) {
                featuredImageRef.current.value = '';
            }

            setFeaturedImage(null);
            setSuccessMessage('Project updated successfully!');

            setTimeout(() => {
                setSuccessMessage('');
            }, 3000);

        } catch (err) {
            setError('Failed to update project');

            setTimeout(() => {
                setError('');
            }, 3000);
        }
        finally {
            setLoading(false); // ✅ re-enable button
        }
    }


    return (
        <div className="dashboard update_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Edit Project</h1>
                <div className="back_btn_wrap">
                    <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
                </div>
                {project ? (
                    <form onSubmit={handleFormSubmit} encType="multipart/form-data">
                        <div className="update_details_wrap">
                            {/* Language Tabs */}
                            <div className="language-tabs" style={{ marginBottom: '20px' }}>
                                <button
                                    type="button"
                                    className={`tab-btn ${activeLanguage === 'en' ? 'active' : ''}`}
                                    onClick={() => setActiveLanguage('en')}
                                    style={{
                                        padding: '10px 20px',
                                        marginRight: '10px',
                                        backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                                        color: activeLanguage === 'en' ? 'white' : 'black',
                                        border: '1px solid #ddd',
                                        cursor: 'pointer',
                                        borderRadius: '4px'
                                    }}
                                >
                                    English
                                </button>
                                <button
                                    type="button"
                                    className={`tab-btn ${activeLanguage === 'es' ? 'active' : ''}`}
                                    onClick={() => setActiveLanguage('es')}
                                    style={{
                                        padding: '10px 20px',
                                        backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                                        color: activeLanguage === 'es' ? 'white' : 'black',
                                        border: '1px solid #ddd',
                                        cursor: 'pointer',
                                        borderRadius: '4px'
                                    }}
                                >
                                    Spanish
                                </button>
                            </div>
                            {/* English Title */}
                            {activeLanguage === 'en' && (
                                <div className="form-group">
                                    <label> Title (English)</label>
                                    <input
                                        type="text"
                                        value={project.title}
                                        required
                                        onChange={(e) => setProject({ ...project, title: e.target.value })}
                                    />
                                </div>
                            )}

                            {/* Spanish Title */}
                            {activeLanguage === 'es' && (
                                <div className="form-group">
                                    <label>Title (Spanish)</label>
                                    <input
                                        type="text"
                                        value={project.spanishData?.title || ''}
                                        onChange={(e) => setProject({
                                            ...project,
                                            spanishData: {
                                                ...project.spanishData,
                                                title: e.target.value
                                            }
                                        })}
                                    />
                                </div>
                            )}

                            {/* <div className="form-group">
                                <label>Type</label>
                                <input
                                    type="text"
                                    value={project.type}
                                    onChange={(e) => setProject({ ...project, type: e.target.value })}
                                />
                            </div> */}

                            {/* English Categories */}
                            {activeLanguage === 'en' && (
                                <div className="form-group">
                                    <label>Categories (English)</label>
                                    <Select
                                        options={categoryOptions}
                                        multi
                                        searchable
                                        labelField="label"
                                        valueField="value"
                                        placeholder="Select categories"
                                        values={selectedCategories}
                                        onChange={(values) => {
                                            setSelectedCategories(values);
                                            setSelectedCategoryIds(values.map(v => v.value));
                                        }}
                                    />
                                </div>
                            )}

                            {/* Spanish Categories */}
                            {activeLanguage === 'es' && (
                                <div className="form-group">
                                    <label>Categories (Spanish)</label>
                                    <Select
                                        options={categoryOptions}
                                        multi
                                        searchable
                                        labelField="label"
                                        valueField="value"
                                        placeholder="Seleccionar categorías"
                                        values={selectedSpanishCategories}
                                        onChange={(values) => {
                                            setSelectedSpanishCategories(values);
                                            setSelectedSpanishCategoryIds(values.map(v => v.value));
                                        }}
                                    />
                                </div>
                            )}

                            {/* English Fields */}
                            {activeLanguage === 'en' && (
                                <>
                                    <div className="form-group">
                                        <label>Ano (English)</label>
                                        <input
                                            type="text"
                                            value={project.ano}
                                            onChange={(e) => setProject({ ...project, ano: e.target.value })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Cliente (English)</label>
                                        <input
                                            type="text"
                                            value={project.cliente}
                                            onChange={(e) => setProject({ ...project, cliente: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Location (English)</label>
                                        <input
                                            type="text"
                                            value={project?.location}
                                            onChange={(e) => setProject({ ...project, location: e.target.value })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Lighting Designer (English)</label>
                                        <input
                                            type="text"
                                            value={project.lightingDesigner}
                                            onChange={(e) => setProject({ ...project, lightingDesigner: e.target.value })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Interior Designer (English)</label>
                                        <input
                                            type="text"
                                            value={project.interiorDesigner}
                                            onChange={(e) => setProject({ ...project, interiorDesigner: e.target.value })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Photography (English)</label>
                                        <input
                                            type="text"
                                            value={project.photography}
                                            onChange={(e) => setProject({ ...project, photography: e.target.value })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Partners (English)</label>
                                        <input
                                            type="text"
                                            value={project.partners}
                                            onChange={(e) => setProject({ ...project, partners: e.target.value })}
                                        />
                                    </div>
                                </>
                            )}

                            {/* Spanish Fields */}
                            {activeLanguage === 'es' && (
                                <>
                                    <div className="form-group">
                                        <label>Ano (Spanish)</label>
                                        <input
                                            type="text"
                                            value={project.spanishData?.ano || ''}
                                            onChange={(e) => setProject({
                                                ...project,
                                                spanishData: {
                                                    ...project.spanishData,
                                                    ano: e.target.value
                                                }
                                            })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Cliente (Spanish)</label>
                                        <input
                                            type="text"
                                            value={project.spanishData?.cliente || ''}
                                            onChange={(e) => setProject({
                                                ...project,
                                                spanishData: {
                                                    ...project.spanishData,
                                                    cliente: e.target.value
                                                }
                                            })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Location (Spanish)</label>
                                        <input
                                            type="text"
                                            value={project.spanishData?.location || ''}
                                            onChange={(e) => setProject({
                                                ...project,
                                                spanishData: {
                                                    ...project.spanishData,
                                                    location: e.target.value
                                                }
                                            })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Lighting Designer (Spanish)</label>
                                        <input
                                            type="text"
                                            value={project.spanishData?.lightingDesigner || ''}
                                            onChange={(e) => setProject({
                                                ...project,
                                                spanishData: {
                                                    ...project.spanishData,
                                                    lightingDesigner: e.target.value
                                                }
                                            })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Interior Designer (Spanish)</label>
                                        <input
                                            type="text"
                                            value={project.spanishData?.interiorDesigner || ''}
                                            onChange={(e) => setProject({
                                                ...project,
                                                spanishData: {
                                                    ...project.spanishData,
                                                    interiorDesigner: e.target.value
                                                }
                                            })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Photography (Spanish)</label>
                                        <input
                                            type="text"
                                            value={project.spanishData?.photography || ''}
                                            onChange={(e) => setProject({
                                                ...project,
                                                spanishData: {
                                                    ...project.spanishData,
                                                    photography: e.target.value
                                                }
                                            })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Partners (Spanish)</label>
                                        <input
                                            type="text"
                                            value={project.spanishData?.partners || ''}
                                            onChange={(e) => setProject({
                                                ...project,
                                                spanishData: {
                                                    ...project.spanishData,
                                                    partners: e.target.value
                                                }
                                            })}
                                        />
                                    </div>
                                </>
                            )}

                            <div className="form-group">
                                <div className="detail_banner_wrap">
                                    <div className="detail_img_grid">
                                        <div className="upload_item">
                                            <label>Featured Image</label>
                                            <input type="file" onChange={handleFeaturedImageChange} ref={featuredImageRef} />
                                        </div>
                                        <div className="detail_img_grid">
                                            {project.featuredImage ? (
                                                <div className="detail_img_item">
                                                    <div className="banner_img_wrap">
                                                        <img src={`${config.BASE_URL}${project.featuredImage}`} alt="Featured" />
                                                    </div>
                                                    <button className="remove_btn" type="button" onClick={() => handleRemoveImage(project.featuredImage)}>Remove</button>
                                                </div>
                                            ) : (
                                                <p>No image available.</p>
                                            )}
                                        </div>

                                    </div>

                                </div>
                            </div>

                            {/* English Center Content */}
                            {activeLanguage === 'en' && (
                                <div className="add_field textareaField repeaterFields">
                                    <h2><b>Center Content (English)</b></h2>
                                    {centerContent && centerContent.length > 0 && centerContent.map((field, index) => (
                                        <div key={index} className="singleReapterFieldContent update">
                                            <div className="add_field">
                                                <div className="form-group">
                                                    <h2>Description</h2>
                                                    <input
                                                        name="description"
                                                        type="text"
                                                        value={field.description}
                                                        placeholder="Description"
                                                        onChange={(event) => handleContentChange(index, event)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="add_field">
                                                <h2>Image</h2>
                                                <div className="form-group">
                                                    <div className="file-upload">
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            name="image"
                                                            onChange={(event) => handleContentImageChange(index, event)}
                                                        />
                                                        <i className="fa fa-camera i-pic-upload"></i>
                                                    </div>
                                                </div>

                                                {field?.image && typeof field?.image !== "object" && (
                                                    <div className="detail_item_inner gallery_inner">
                                                        <div className="detail_img_grid">
                                                            <div className="detail_img_item">
                                                                <div className="banner_img_wrap">
                                                                    <img src={`${config.BASE_URL}${field?.image}`} alt="Featured" />
                                                                </div>
                                                                <button className="remove_btn" type="button" onClick={() => handleRemoveImage(field?.image, "centerContent", index)}>Remove</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="add_field">
                                                <h2>Is Full Width?</h2>
                                                <Checkbox
                                                    onChange={e => handleCheckboxChange(index, e.checked)}
                                                    checked={field?.isFullWidth}
                                                ></Checkbox>
                                            </div>

                                            <button type="button" onClick={() => removeContentFields(index)}>
                                                Remove
                                            </button>
                                        </div>
                                    ))}
                                    <button type="button" onClick={addContentFields}>Add More</button>
                                </div>
                            )}

                            {/* Spanish Center Content */}
                            {activeLanguage === 'es' && (
                                <div className="add_field textareaField repeaterFields">
                                    <h2><b>Center Content (Spanish)</b></h2>
                                    {spanishCenterContent && spanishCenterContent.length > 0 && spanishCenterContent.map((field, index) => (
                                        <div key={index} className="singleReapterFieldContent update">
                                            <div className="add_field">
                                                <div className="form-group">
                                                    <h2>Description</h2>
                                                    <input
                                                        name="description"
                                                        type="text"
                                                        value={field.description}
                                                        placeholder="Descripción"
                                                        onChange={(event) => handleSpanishContentChange(index, event)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="add_field">
                                                <h2>Image</h2>
                                                <div className="form-group">
                                                    <div className="file-upload">
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            name="image"
                                                            onChange={(event) => handleSpanishContentImageChange(index, event)}
                                                        />
                                                        <i className="fa fa-camera i-pic-upload"></i>
                                                    </div>
                                                </div>

                                                {field?.image && typeof field?.image !== "object" && (
                                                    <div className="detail_item_inner gallery_inner">
                                                        <div className="detail_img_grid">
                                                            <div className="detail_img_item">
                                                                <div className="banner_img_wrap">
                                                                    <img src={`${config.BASE_URL}${field?.image}`} alt="Featured" />
                                                                </div>
                                                                <button className="remove_btn" type="button" onClick={() => handleRemoveImage(field?.image, "spanishCenterContent", index)}>Eliminar</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="add_field">
                                                <h2>Is Full Width?</h2>
                                                <Checkbox
                                                    onChange={e => handleSpanishCheckboxChange(index, e.checked)}
                                                    checked={field?.isFullWidth}
                                                ></Checkbox>
                                            </div>

                                            <button type="button" onClick={() => removeSpanishContentFields(index)}>
                                                Remove
                                            </button>
                                        </div>
                                    ))}
                                    <button type="button" onClick={addSpanishContentFields}>Agregar Más</button>
                                </div>
                            )}

                            <div className="form-group">
                                <div className="form-group">
                                    <label>Upload Gallery Images</label>
                                    <input type="file" multiple onChange={handleNewImageChange} ref={fileInputRef} />
                                </div>
                                <div className="detail_item_inner gallery_inner">
                                    <div className="detail_img_grid">
                                        {project?.galleryImages && project.galleryImages.map((image, index) => (
                                            <div className="detail_image_item" key={index}>
                                                <div className="detail_img_item galleryImages">
                                                    <img src={`${config.BASE_URL}${image}`} alt={`Project ${index}`} />
                                                </div>
                                                <button className="remove_btn" type="button" onClick={() => handleRemoveImage(image)}>Remove</button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="detail_banner_wrap">
                                    <div className="detail_img_grid">

                                        <div className="upload_item">
                                            <label>Center Content Banner Image</label>
                                            <input type="file" onChange={handleBannerImageChange} ref={bannerImageRef} />
                                        </div>
                                        <div className="detail_img_grid">
                                            {project.contentBanner ? (
                                                <div className="detail_img_item">
                                                    <div className="banner_img_wrap">
                                                        <img src={`${config.BASE_URL}${project.contentBanner}`} alt="Featured" />
                                                    </div>
                                                    <button className="remove_btn" type="button" onClick={() => handleRemoveImage(project.contentBanner)}>Remove</button>
                                                </div>
                                            ) : (
                                                <p>No image available.</p>
                                            )}
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className="add_field checkbox_field">
                                <Checkbox
                                    onChange={(e) => setProject({ ...project, isFeatured: e.checked })}
                                    checked={project.isFeatured}
                                    required={project.isHomePageFeatured && !project.isFeatured ? true : false}
                                ></Checkbox>
                                <h4>Is Featured?</h4>
                            </div>
                            <span style={{color:'red'}}>{project?.isHomePageFeatured && !project?.isFeatured ? "A HomePage Featured project must also be marked as Featured. " : ''}</span>

                            <div className="add_field checkbox_field">
                                <Checkbox
                                    onChange={(e) => setProject({ ...project, isHomePageFeatured: e.checked })}
                                    checked={project.isHomePageFeatured}
                                ></Checkbox>
                                <h4>Is HomePage Featured?</h4>
                            </div>

                            {/* if (project.isHomePageFeatured && !project.isFeatured) {
                                alert("A HomePage Featured project must also be marked as Featured!");
                            return;
} */}


                            <div className="update_btn_wrap">
                                {/* <button className="update_btn" type="submit">Update Project</button> */}
                                <button className="update_btn" type="submit" disabled={loading}>
                                    {loading ? 'Submitting...' : 'Update Project'}
                                </button>

                            </div>
                            {successMessage && <p className="success-message">{successMessage}</p>}
                            {error && <p className="error-message">{error}</p>}
                        </div>
                    </form>
                ) : (
                    <h5>Project not found!</h5>
                )}
            </div>
        </div>
    );
}

export default UpdateProjectDetail;
